import { render, staticRenderFns } from "./myDishes.vue?vue&type=template&id=53fb5369&scoped=true&class=my-dishes"
import script from "./myDishes.vue?vue&type=script&lang=js"
export * from "./myDishes.vue?vue&type=script&lang=js"
import style0 from "./myDishes.vue?vue&type=style&index=0&id=53fb5369&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fb5369",
  null
  
)

export default component.exports